import React, { Children, FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

// Interface

export type ContainerGridDisplayOptions =
  | 'featuredOnLeft'
  | 'featuredOnRight'
  | 'threeColumns';

export interface ContainerGridProps {
  children: React.ReactNode;
  as?: any;
  numberOfItems: number;
  display?: ContainerGridDisplayOptions;
}

export interface StyledContainerGridProps {
  numberOfItems: number;
  display: ContainerGridDisplayOptions;
}

// Styles

const StyledContainerGrid = styled.div<StyledContainerGridProps>`
  ${({
    theme: { colors, media, maxMedia, borders, borderRadii },
    numberOfItems,
    display,
  }) => css`
    border-radius: ${borderRadii.small};
    overflow: hidden;
    border: solid 1px ${colors.darkBlue};

    @media (max-width: ${maxMedia.medium}) {
      > * + * {
        border-top: solid 1px ${colors.darkBlue};
      }
    }

    @media (min-width: ${media.medium}) {
      display: grid;

      ${
        display === 'threeColumns'
          ? css`
              grid-template-columns: repeat(3, 1fr);

              > *:not(:nth-of-type(3n)) {
                border-right: ${borders.darkBlue};
              }
            `
          : css`
    
      grid-template-columns: repeat(4, 1fr);
      grid-template-rows: repeat(2, auto);

      > * {
        &:nth-of-type(1) {
          grid-column: span 2;
          grid-row: span 2;

          ${
            display === 'featuredOnLeft'
              ? css`
                  border-right: ${borders.darkBlue};
                `
              : css`
                  grid-column-start: 3;
                  grid-column-end: 5;
                  border-left: ${borders.darkBlue};
                `
          }
        }

        &:nth-of-type(2) {
          border-bottom: ${borders.darkBlue};
          grid-column: span 2;

          ${
            display === 'featuredOnRight' &&
            css`
              grid-row-start: 1;
            `
          }
        }

        &:nth-of-type(3) {
          border-right: ${borders.darkBlue};

          ${
            numberOfItems === 3 &&
            css`
              border-right: 0;
              grid-column: span 2;
            `
          };

          ${
            display === 'featuredOnRight' &&
            css`
              grid-column-start: 1;

              ${numberOfItems === 3 &&
              css`
                grid-column: span 2;
              `};
            `
          }
        }

        `
      }
      }


    }


  `};
`;

// JSX

export const ContainerGrid: FC<ContainerGridProps> = ({
  children,
  numberOfItems,
  display = 'featuredOnLeft',
  ...rest
}) => (
  <StyledContainerGrid
    numberOfItems={numberOfItems}
    display={display}
    {...rest}
  >
    {children}
  </StyledContainerGrid>
);

export default ContainerGrid;
